import { Icon } from "@circleco/compass/components/Icon";
import { Link } from "@circleco/compass/components/Link";

import { t } from "@/i18n-js/instance";
import { classNames } from "@/react/helpers/twMergeWithCN";

interface ViewOrderDetailsLineProps {
  className?: string;
  isLoading: boolean;
  toggle: () => void;
  value: boolean;
}

export const ViewOrderDetailsCollapseLine = ({
  className,
  isLoading,
  value,
  toggle,
}: ViewOrderDetailsLineProps) => (
  <Link
    asButton
    variant="custom"
    typography="label-xs"
    color="secondary"
    className={className}
    type="button"
    onClick={toggle}
    disabled={isLoading}
  >
    <span
      className={classNames("flex flex-row items-center gap-x-1", {
        "text-disabled": isLoading,
        "hover:underline cursor-pointer": !isLoading,
      })}
    >
      {t("view_order_details")}
      <Icon name={value ? "chevron-top" : "chevron-down"} size="sm" />
    </span>
  </Link>
);
